/* istanbul ignore file */

export default {
  "privacy-policy": "https://www.lowi.es/privacidad/",
  "terms-and-conditions": "https://www.lowi.es/datos-informacion-general/",
  "cookie-preferences": "https://www.lowi.es/politica-de-cookies/",
};
